// Copyright (c) 2022 by Move Closer.

import { Module } from 'vuex'

import { UserData } from '../auth/shared'

import { State } from '../shared/contracts/store'

import { ProfileState } from './contracts/store'

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export const storeFactory = (): Module<ProfileState, State> => ({
  namespaced: true,

  state: () => ({
    user: null
  }),

  mutations: {
    SET_USER (state, user: UserData | null) {
      state.user = user
    }
  },

  getters: {
    fullName: (state) => state.user ? `${state.user.firstName} ${state.user.lastName}` : '',
    user: (state) => state.user
  }
})
